import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPrePrintedForms,
  getPrePrintedHTML,
} from "../../../../../actions/accidentDashboard";
import { CODIGO_AUDITORIA, registrarAccionFrontend } from "../../../../../actions/audit";
import { parseHTMLToReact } from "../../../../../utils/util";
import PrintAndDownloadDialog from "../../../../commons/dialog/PrintAndDownloadDialog";
import { StyledFlex } from "../../../../styled/flex";
import CardTitle from "../cardTitle";
import AccidentFormsCards from "./accidentPrePrintedFormsCards";

const AccidentForms = () => {
  const dispatch = useDispatch();

  const forms = useSelector((state) => state.accidentDashboard.prePrintedForms);
  const accident = useSelector((state) => state.accidentDashboard.accident);
  const html = useSelector((state) => state.accidentDashboard.prePrintedHTML);

  const [openModal, setOpenModal] = useState(false);
  const [selectedForm, setSelectedForm] = useState({});

  useEffect(() => {
    dispatch(
      getPrePrintedForms(accident.mlCloudCoreArtId, accident.idSiniestro),
    );
  }, []);

  const handleCloseModal = () => {
    setSelectedForm({});
    setOpenModal(false);
  };

  const generatePrePrintedHTML = (form) => {
    setSelectedForm(form);
    setOpenModal(true);
    dispatch(
      getPrePrintedHTML({
        accidentId: accident.idSiniestro,
        WRIId: accident.mlCloudCoreArtId,
        templateId: form.idPlantillaPreImpresion,
      }),
    );
  };

  const handleBeforePrint = () => {
    dispatch(registrarAccionFrontend({
      idArt: accident.mlCloudCoreArtId,
      code: CODIGO_AUDITORIA.IMPRIMIR_FORMULARIO_PREIMPRESO,
      siniestro: accident.idSiniestro,
      numeroDocumento: accident.documento,
      requestInput: `plantilla ${selectedForm.idPlantillaPreImpresion}`,
    }));
    return Promise.resolve(true);
  };

  return (
    <StyledFlex.ColumnContainer>
      <CardTitle title="FORMULARIOS" color="primary" />
      <AccidentFormsCards
        data={forms.data}
        loading={forms.isFetching}
        generatePrePrintedHTML={generatePrePrintedHTML}
      />
      <PrintAndDownloadDialog
        maxWidth="lg"
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        childComponent={
          <React.Fragment>{parseHTMLToReact(html.data)}</React.Fragment>
        }
        loading={html.isFetching || !openModal}
        title={selectedForm.nombre}
        showDownloadButton={false}
        onBeforePrint={handleBeforePrint}
        reactToPrintProps={{ suppressErrors: true }}
      />
    </StyledFlex.ColumnContainer>
  );
};

export default AccidentForms;
